module.exports = __webpack_public_path__ + "static/iPad-USB-C-9ed901196ab160ea3a3a96888ac22679.png";